import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@quorum/api';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-ford-dashboard',
  templateUrl: './ford-dashboard.component.html',
  styleUrls: ['./ford-dashboard.component.scss'],
})

export class FordDashboardComponent implements OnInit, OnChanges {
  dashboardData: any;
  outstandingFieldServiceActionsUi: any = { collapsed: false };
  generalWarrantyUi: any = { collapsed: true };
  warningMessagesUi: any = { collapsed: true };
  extendedCoveragesUi: any = { collapsed: true };
  warrantyRepairHistoryUi: any = { collapsed: true };
  @Input() collapsed: boolean;

  constructor(public serviceLaneFacade: ServiceLaneFacade) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collapsed.currentValue) {
      this.outstandingFieldServiceActionsUi.collapsed = changes.collapsed.firstChange ? false : true;
      this.generalWarrantyUi.collapsed = true;
      this.warningMessagesUi.collapsed = true;
      this.extendedCoveragesUi.collapsed = true;
      this.warrantyRepairHistoryUi.collapsed = true;
    } else {
      this.outstandingFieldServiceActionsUi.collapsed = false;
      this.generalWarrantyUi.collapsed = false;
      this.warningMessagesUi.collapsed = false;
      this.extendedCoveragesUi.collapsed = false;
      this.warrantyRepairHistoryUi.collapsed = false;
    }
  }

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }

  getWarningTitle(type: string) {
    switch (type) {
      case 'N':
        return `Normal Warning Message`;
      case 'W':
        return 'Warranty Warning Message';
      case 'M':
        return 'Morsii Warning Message';
    }
  }

  isArray(array: any) {
    return Array.isArray(array);
  }
}
